export default {
  id: 'reports',
  title: 'Reports (admin)',
  note: 'The G6 reports index, a single report detail view, and the generate-report form.',
  texts: {
    // ── index ────────────────────────────────────────────────────────────────
    'reports.list.crumb': 'G6 Reports',
    'reports.list.title': 'G6 Reports',
    'reports.list.subtitle': 'UIC 30301 inter-carrier accounting reports',
    'reports.list.subtitleDemo': ' · showing sample data',
    'reports.list.action.emailTemplate': 'Email template',
    'reports.list.action.export': 'Export',
    'reports.list.action.exportTitle': 'Export the visible reports index as CSV',
    'reports.list.action.generate': 'Generate report',
    'reports.list.error.load': 'Failed to load reports',
    'reports.list.error.download': 'Failed to download report',
    'reports.list.demoDownloadAlert': 'Demo data — download will work once real reports are generated.',
    'reports.list.kpi.totalCleared': 'Total cleared · period',
    'reports.list.kpi.acrossReports': 'across {count} reports',
    'reports.list.kpi.recordsDelivered': 'Records delivered',
    'reports.list.kpi.overdueQueued': 'Overdue / queued',
    'reports.list.kpi.actionRequired': 'Action required',
    'reports.list.template.title': 'Report email template',
    'reports.list.template.placeholdersLabel': 'Placeholders:',
    'reports.list.template.subject': 'Subject',
    'reports.list.template.body': 'Body',
    'reports.list.template.save': 'Save template',
    'reports.list.template.saving': 'Saving…',
    'reports.list.template.saved': 'Saved.',
    'reports.list.template.saveFailed': 'Save failed',
    'reports.list.tab.all': 'All',
    'reports.list.tab.outgoing': 'Outgoing',
    'reports.list.tab.incoming': 'Incoming',
    'reports.list.search.placeholder': 'Search report ID, partner, RICS…',
    'reports.list.count': '{count} reports',
    'reports.list.col.reportId': 'Report ID',
    'reports.list.col.direction': 'Direction',
    'reports.list.col.period': 'Period',
    'reports.list.col.partner': 'Partner',
    'reports.list.col.amount': 'Amount',
    'reports.list.col.records': 'Records',
    'reports.list.col.status': 'Status',
    'reports.list.col.delivered': 'Delivered',
    'reports.list.col.actions': 'Actions',
    'reports.list.csv.reportId': 'Report ID',
    'reports.list.csv.direction': 'Direction',
    'reports.list.csv.period': 'Period',
    'reports.list.csv.partner': 'Partner',
    'reports.list.csv.amount': 'Amount',
    'reports.list.csv.status': 'Status',
    'reports.list.csv.records': 'Records',
    'reports.list.csv.delivered': 'Delivered',
    'reports.list.csv.invoicingRics': 'Invoicing RICS',
    'reports.list.csv.currency': 'Currency',
    'reports.list.loading': 'Loading…',
    'reports.list.empty': 'No reports.',
    'reports.list.direction.incoming': '↓ Incoming',
    'reports.list.direction.outgoing': '↑ Outgoing',
    'reports.list.row.view': 'View',
    'reports.list.row.viewTitle': 'View G6 report details',
    'reports.list.row.downloadCsvTitle': 'Download CSV',
    'reports.list.row.downloadG6Title': 'Download G6 JSON (UIC schema 1.1.0)',
    'reports.list.row.copyIdTitle': 'Copy report ID',
    'reports.list.foot.a': 'Period total:',
    'reports.list.foot.b': 'across',
    'reports.list.foot.c': 'reports',
    'reports.list.modal.generateTitle': 'Generate New Report',

    // ── detail ───────────────────────────────────────────────────────────────
    'reports.detail.crumb': 'Reports / {reportId}',
    'reports.detail.crumbLoading': 'Reports / Loading…',
    'reports.detail.crumbError': 'Reports / Error',
    'reports.detail.loading': 'Loading report…',
    'reports.detail.error.load': 'Failed to load report',
    'reports.detail.error.download': 'Download failed',
    'reports.detail.back': '← Back',
    'reports.detail.action.csv': 'CSV',
    'reports.detail.action.downloadG6': 'Download G6 JSON',
    'reports.detail.action.downloading': 'Downloading…',
    'reports.detail.kpi.balance': 'Balance',
    'reports.detail.kpi.accountingRecords': 'Accounting records',
    'reports.detail.kpi.transactionsSub': 'transactions in this delivery',
    'reports.detail.kpi.deliveryUuid': 'Delivery UUID',
    'reports.detail.deliveryDetails': 'Delivery Details',
    'reports.detail.field.invoicingParty': 'Invoicing party',
    'reports.detail.field.invoiceRecipient': 'Invoice recipient',
    'reports.detail.field.periodStart': 'Period start',
    'reports.detail.field.periodEnd': 'Period end',
    'reports.detail.field.paymentType': 'Payment type',
    'reports.detail.field.created': 'Created',
    'reports.detail.records.heading': 'Accounting Records ({count})',
    'reports.detail.records.empty': 'No records yet — re-generate the report to build the full G6 file.',
    'reports.detail.col.index': '#',
    'reports.detail.col.type': 'Type',
    'reports.detail.col.txType': 'Tx type',
    'reports.detail.col.date': 'Date',
    'reports.detail.col.amount': 'Amount',
    'reports.detail.col.dc': 'D/C',
    'reports.detail.panel.record': 'Record {n}',
    'reports.detail.sect.record': 'Record',
    'reports.detail.sect.transaction': 'Transaction',
    'reports.detail.sect.subject': 'Subject',
    'reports.detail.sect.accountedAmounts': 'Accounted Amounts',
    'reports.detail.field.recordId': 'Record ID',
    'reports.detail.field.accountingType': 'Accounting type',
    'reports.detail.field.salesType': 'Sales type',
    'reports.detail.field.standard': 'Standard',
    'reports.detail.field.type': 'Type',
    'reports.detail.field.timestamp': 'Timestamp',
    'reports.detail.field.contract': 'Contract',
    'reports.detail.field.items': 'Items',
    'reports.detail.field.train': 'Train',
    'reports.detail.field.travelDate': 'Travel date',
    'reports.detail.field.carriers': 'Carriers',
    'reports.detail.field.retailer': 'Retailer',
    'reports.detail.amount.gross': 'Gross',
    'reports.detail.amount.afterSaleFee': 'After-sale fee',
    'reports.detail.amount.commission': 'Commission',
    'reports.detail.amount.meta': '{currency} · scale {scale}',
    'reports.detail.paymentType.bankTransfer': 'Bank transfer',
    'reports.detail.paymentType.bccClearing': 'BCC clearing',
    'reports.detail.paymentType.currentAccount': 'Current account',
    'reports.detail.paymentType.currentAccountClearing': 'CA clearing',
    'reports.detail.txType.booking': 'Booking',
    'reports.detail.txType.cancellation': 'Cancellation',
    'reports.detail.txType.exchangeBooking': 'Exch. booking',
    'reports.detail.txType.exchangeCancellation': 'Exch. cancel',
    'reports.detail.txType.compensation': 'Compensation',
    'reports.detail.txType.manualRefund': 'Refund',
    'reports.detail.txType.prebookingTimeExtension': 'Prebooking ext.',

    // ── generate form ────────────────────────────────────────────────────────
    'reports.generate.error.allFieldsRequired': 'All fields are required',
    'reports.generate.error.failed': 'Failed to generate report',
    'reports.generate.field.partnership': 'Partnership',
    'reports.generate.field.partnershipPlaceholder': 'Select a partnership',
    'reports.generate.field.startDate': 'Start Date',
    'reports.generate.field.endDate': 'End Date',
    'reports.generate.submit': 'Generate G6 Report',
    'reports.generate.submitBusy': 'Generating...',
  },
}
